var __WEBPACK_NAMESPACE_OBJECT__ = kolibriCoreAppGlobal.utils.redirectBrowser;